import React from 'react'
import service from "../../assets/images/resource/simulator.png";

const ProductOne = () => {
    return (
        <section>
            <figure>
                <img src={service} alt="" />
            </figure>
            <h2>Enhancing Real-world Experiences with AR <span>Technology.</span> </h2>
            <h3>Simulator </h3>
            <p>The applications of AR are vast and diverse. From entertainment and gaming, where users can see virtual characters in their surroundings, to education, where complex subjects can be visualized and explained in an immersive way,. We understand that every business has unique needs. Our technology solutions are tailored to match your specific requirements, ensuring optimal performance and efficiency. Our dedicated team of technology professionals comprises experienced engineers, developers, and researchers who are passionate about pushing the boundaries of technology. We understand that every business has unique needs. Our technology solutions are tailored to match your specific requirements, ensuring optimal performance and efficiency.</p>
            <p>
                The applications of AR are vast and diverse. From entertainment and gaming, where users can see virtual characters in their surroundings, to education, where complex subjects can be visualized and explained in an immersive way,. We understand that every business has unique needs. Our technology solutions are tailored to match your specific requirements, ensuring optimal performance and efficiency.
            </p>
        </section>
    )
}

export default ProductOne